import { render, staticRenderFns } from "./declareHistory.vue?vue&type=template&id=62b0a07e&"
import script from "./declareHistory.vue?vue&type=script&lang=js&"
export * from "./declareHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports